import { useMemo } from 'react'
import { useRouter } from 'next/router'

import { getParams } from 'utils/getURLData'
import { checkKeyInObject, getCheckoxParams, getDateParams, getMultiSelectParams } from './utils'
import { checkboxKeys, multiSelectKeys } from 'constants/search-data/search-data'
import { Key, categories } from 'constants/search-data/library-search-data'
import { IInitParams } from 'constants/types/search.types'

const useInitParams = () => {
  const router = useRouter()
  const queryParams = useMemo(() => getParams(router.asPath), [])
  const initParams = useMemo(() => {
    const init = {} as IInitParams

    checkboxKeys.forEach((key) => {
      if (checkKeyInObject(queryParams, key)) {
        init[key] = getCheckoxParams(queryParams[key] as string)
      }
    })

    multiSelectKeys.forEach((key) => {
      if (checkKeyInObject(queryParams, key)) {
        init[key] = queryParams[key]
          .split(',')
          .filter((item) => item)
          .map((item) => {
            return { key: key, value: item, label: '' }
          })
      }
    })

    if (checkKeyInObject(queryParams, Key.DATES)) {
      init[Key.DATES] = getDateParams(queryParams[Key.DATES] as string)
    }

    if (checkKeyInObject(queryParams, Key.CATEGORY)) {
      init[Key.CATEGORY] = getMultiSelectParams(queryParams[Key.CATEGORY] as string, categories)
    }
    if (checkKeyInObject(queryParams, Key.TEXT)) {
      init[Key.TEXT] = queryParams[Key.TEXT] as string
    }

    if (checkKeyInObject(queryParams, Key.PAGE)) {
      init[Key.PAGE] = queryParams[Key.PAGE] as string
    }
    return init
  }, [])

  return { initParams, queryParams }
}

export default useInitParams
